import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import NumberFormat from 'react-number-format';
import { omit } from 'lodash';
import TextField from './TextField';
const NumberFormatCustom = React.forwardRef((props, ref) => {
    const { onChange, name } = props, other = __rest(props, ["onChange", "name"]);
    return (_jsx(NumberFormat, Object.assign({}, other, { getInputRef: ref, onValueChange: values => {
            onChange({
                target: {
                    name,
                    value: values.value,
                },
            });
        } })));
});
function NumberField(props) {
    const { align, numberProps } = props;
    const newProps = Object.assign(Object.assign({}, omit(props, 'numberProps')), { align: align || 'left', InputProps: {
            inputComponent: NumberFormatCustom,
        }, inputProps: Object.assign(Object.assign({}, numberProps), { allowedDecimalSeparators: [',', '.'] }) });
    return _jsx(TextField, Object.assign({}, newProps));
}
export default NumberField;
